import { useState } from "react";
import { useData } from "@/context/DataContext";
import { Reveal, SectionHeader } from "@/components/shared/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FaqSection = () => {
  const { data } = useData();
  const faqs = data.faq || [];
  const [cat, setCat] = useState("Alla");
  if (!faqs.length) return null;

  const cats = ["Alla", ...new Set(faqs.map((f) => f.category).filter(Boolean))];
  const filtered = cat === "Alla" ? faqs : faqs.filter((f) => f.category === cat);

  return (
    <section data-testid="faq-section" className="relative py-24 sm:py-32 bg-[#0A0B0D]">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Reveal>
          <SectionHeader kicker="Vanliga frågor" title="FAQ" center />
        </Reveal>
        <div className="mt-8 flex flex-wrap gap-2 justify-center">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`faq-filter-${c}`}
              className={`rounded-full px-4 py-2 text-xs font-mono uppercase tracking-widest border transition-colors ${
                cat === c ? "bg-amber-500 text-black border-amber-500" : "border-white/15 text-white/60 hover:border-amber-500/50"
              }`}>
              {c}
            </button>
          ))}
        </div>
        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {filtered.map((f) => (
            <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${f.id}`} className="rounded-xl border border-white/10 bg-[#14161A] px-5 overflow-hidden">
              <AccordionTrigger className="font-display text-lg sm:text-xl font-bold uppercase text-white hover:text-amber-500 hover:no-underline text-left py-5">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="text-white/65 leading-relaxed pb-5 text-base">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
